/** In-page section scroll for the marketing landing (HashRouter-safe). */
export function scrollToLandingSection(sectionId: string): void {
  const el = document.getElementById(sectionId);
  if (!el) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  el.scrollIntoView({
    behavior: reducedMotion ? 'instant' : 'smooth',
    block: 'start'
  });
}
